module.exports = __webpack_public_path__ + "img/FlagRestOfWorld.a2d81e43.png";